
import React from "react";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const AuditTrail = () => (<div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
  <div className="bg-gray-50 min-h-screen">
    <div className=" ">
      <div className="flex items-center justify-between mb-6">
        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">Audit Trail</h1>
          <p className="text-gray-500 mt-1">Track all amendments, rate changes, territory expansions with timeline</p>
        </div> */}

        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="ClipboardList" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Audit Trail</h1>
                <p className="text-muted mb-0 small">Track all amendments, rate changes, territory expansions with timeline</p>
              </div>
</div>

        <div className="flex gap-2">
          <select className="border rounded-lg px-4 py-2 bg-white">
            <option>All Contracts</option>
            <option>Summit Ridge Merch</option>
            <option>Golden State Apparel</option>
          </select>
          <select className="border rounded-lg px-4 py-2 bg-white">
            <option>All Changes</option>
            <option>Rate Changes</option>
            <option>Territory</option>
            <option>Amendments</option>
          </select>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">Export Audit Log</button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl shadow p-2 text-center"><p className="text-2xl font-bold">47</p><p className="text-xs text-gray-500">Total Changes (YTD)</p></div>
        <div className="bg-white rounded-xl shadow p-2 text-center"><p className="text-2xl font-bold text-blue-600">12</p><p className="text-xs text-gray-500">Amendments</p></div>
        <div className="bg-white rounded-xl shadow p-2 text-center"><p className="text-2xl font-bold text-purple-600">8</p><p className="text-xs text-gray-500">Rate Changes</p></div>
        <div className="bg-white rounded-xl shadow p-2 text-center"><p className="text-2xl font-bold text-green-600">5</p><p className="text-xs text-gray-500">Territory Expansions</p></div>
      </div>

      <div className="grid grid-cols-3 gap-6">
        {/* Timeline */}
        <div className="col-span-2 bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-6">Change Timeline — Summit Ridge Merch (Aurora Animation)</h5>
          <div className="relative">
            <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gray-200"></div>

            {/* Amendment #3 — Territory Expansion */}
            <div className="relative flex gap-4 mb-8">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#128221;</div>
              <div className="bg-blue-50 rounded-lg p-4 flex-1 border border-blue-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">Amendment #3 — Territory Expansion</p>
                    <p className="text-sm text-gray-600 mt-1">Added Canada to licensed territory. Previously US only.</p>
                  </div>
                  <span className="text-xs text-gray-400">Mar 15, 2026</span>
                </div>
                <div className="mt-2 flex gap-2">
                  <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-xs">Territory</span>
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Approved</span>
                </div>
                <p className="text-xs text-gray-400 mt-2">Changed by: Sarah Mitchell | Approved by: David Chen</p>
              </div>
            </div>

            {/* Rate Adjustment — Tier 3 Added */}
            <div className="relative flex gap-4 mb-8">
              <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#128176;</div>
              <div className="bg-purple-50 rounded-lg p-4 flex-1 border border-purple-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">Rate Adjustment — Tier 3 Added</p>
                    <p className="text-sm text-gray-600 mt-1">Added Tier 3: 5% for sales above $2M. Previously 2-tier structure (8% + 6%).</p>
                    <div className="mt-2 bg-white rounded p-2 text-xs font-mono">
                      <span className="text-red-500 line-through">Tier 1: 8%, Tier 2: 6%</span><br />
                      <span className="text-green-600">Tier 1: 8%, Tier 2: 6%, Tier 3: 5% (&gt;$2M)</span>
                    </div>
                  </div>
                  <span className="text-xs text-gray-400">Feb 1, 2026</span>
                </div>
                <div className="mt-2 flex gap-2">
                  <span className="bg-purple-100 text-purple-700 px-2 py-0.5 rounded text-xs">Rate Change</span>
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Approved</span>
                </div>
                <p className="text-xs text-gray-400 mt-2">Changed by: Legal Team | Effective: Q1 2026</p>
              </div>
            </div>

            {/* Product Category Addition — Accessories */}
            <div className="relative flex gap-4 mb-8">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#128230;</div>
              <div className="bg-orange-50 rounded-lg p-4 flex-1 border border-orange-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">Product Category Addition — Accessories</p>
                    <p className="text-sm text-gray-600 mt-1">Added "Accessories" (bags, wallets, phone cases) to licensed product categories.</p>
                  </div>
                  <span className="text-xs text-gray-400">Jan 10, 2026</span>
                </div>
                <div className="mt-2 flex gap-2">
                  <span className="bg-orange-100 text-orange-700 px-2 py-0.5 rounded text-xs">Product Category</span>
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Approved</span>
                </div>
              </div>
            </div>

            {/* Contract Renewal — 3-Year Extension */}
            <div className="relative flex gap-4 mb-8">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#9989;</div>
              <div className="bg-green-50 rounded-lg p-4 flex-1 border border-green-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">Contract Renewal — 3-Year Extension</p>
                    <p className="text-sm text-gray-600 mt-1">Original 2-year term extended to 3 years. New expiry: Dec 31, 2027.</p>
                  </div>
                  <span className="text-xs text-gray-400">Dec 15, 2025</span>
                </div>
                <div className="mt-2 flex gap-2">
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Renewal</span>
                </div>
              </div>
            </div>

            {/* Minimum Guarantee Increase */}
            <div className="relative flex gap-4 mb-8">
              <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#128176;</div>
              <div className="bg-red-50 rounded-lg p-4 flex-1 border border-red-200">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">Minimum Guarantee Increase</p>
                    <p className="text-sm text-gray-600 mt-1">Annual minimum guarantee increased from $20,000 to $30,000 per contract review.</p>
                    <div className="mt-2 bg-white rounded p-2 text-xs font-mono">
                      <span className="text-red-500 line-through">Min Guarantee: $20,000/yr</span><br />
                      <span className="text-green-600">Min Guarantee: $30,000/yr</span>
                    </div>
                  </div>
                  <span className="text-xs text-gray-400">Oct 1, 2025</span>
                </div>
                <div className="mt-2 flex gap-2">
                  <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs">Financial</span>
                </div>
              </div>
            </div>

            {/* Original Contract Executed */}
            <div className="relative flex gap-4">
              <div className="w-12 h-12 bg-gray-500 rounded-full flex items-center justify-center text-white text-lg z-10 flex-shrink-0">&#128196;</div>
              <div className="bg-gray-100 rounded-lg p-4 flex-1 border border-gray-200">
                <div className="flex justify-between items-start">
                  <p className="font-semibold">Original Contract Executed</p>
                  <span className="text-xs text-gray-400">Jan 1, 2025</span>
                </div>
                <p className="text-sm text-gray-600 mt-1">Initial license agreement signed. US territory, Apparel + Toys, 8% royalty, $20K minimum.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Summary Panel */}
        <div className="space-y-4">
          <div className="bg-white rounded-xl shadow p-5">
            <h5 className="font-semibold mb-3">Contract Evolution</h5>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-gray-500">Original Rate</span><span>8%</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Current Rate</span><span className="font-semibold">8% / 6% / 5% (tiered)</span></div>
              <hr />
              <div className="flex justify-between"><span className="text-gray-500">Original Territory</span><span>US only</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Current Territory</span><span className="font-semibold">US + Canada</span></div>
              <hr />
              <div className="flex justify-between"><span className="text-gray-500">Original Categories</span><span>2</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Current Categories</span><span className="font-semibold">4</span></div>
              <hr />
              <div className="flex justify-between"><span className="text-gray-500">Original Min Guarantee</span><span>$20,000</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Current Min Guarantee</span><span className="font-semibold">$30,000</span></div>
              <hr />
              <div className="flex justify-between"><span className="text-gray-500">Amendments</span><span className="font-semibold">3</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Total Changes</span><span className="font-semibold">6</span></div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow p-5">
            <h5 className="font-semibold mb-3">Version History</h5>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 p-2 bg-blue-50 rounded"><span className="font-mono text-xs bg-blue-200 px-1 rounded">v3.0</span><span>Current</span><span className="text-xs text-gray-400 ml-auto">Mar 2026</span></div>
              <div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer"><span className="font-mono text-xs bg-gray-200 px-1 rounded">v2.0</span><span>Rate + Category</span><span className="text-xs text-gray-400 ml-auto">Jan 2026</span></div>
              <div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer"><span className="font-mono text-xs bg-gray-200 px-1 rounded">v1.1</span><span>Renewal</span><span className="text-xs text-gray-400 ml-auto">Dec 2025</span></div>
              <div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer"><span className="font-mono text-xs bg-gray-200 px-1 rounded">v1.0</span><span>Original</span><span className="text-xs text-gray-400 ml-auto">Jan 2025</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></div></div></div></div>
);

export default AuditTrail;
